import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'USERS' });



// WEBPACK FOOTER //
// ./src/frontend/modules/users/handlers.js